import $ from 'jquery';
import datepickerFactory from 'jquery-datepicker';
import datepickerJAFactory from 'jquery-datepicker/i18n/jquery.ui.datepicker-en-AU';

datepickerFactory($);
datepickerJAFactory($);
(function ($) {
    //get specific url parameter
    $.urlParam = function (name) {
        var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href) ? new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href) : '';
        return results[1] || 0;
    };


    function replaceQueryParam(param, newval, search) {
        var regex = new RegExp("([?;&])" + param + "[^&;]*[;&]?");
        var query = search.replace(regex, "$1").replace(/&$/, '');

        return (query.length > 2 ? query + "&" : "?") + (newval ? param + "=" + newval : '');
    }


    //Last link to pagination
    $('.pag-last').each(function () {
        var page = $(this).data('page');
        $(this).click(function () {
            window.location = '/search' + replaceQueryParam('page_number', page, window.location.search);
        });
    });

    $(".contributor-images img").on("contextmenu", function (e) {
        return false;
    });

    var app = {
        init: function () {
            toggle_class.init();
            advanced_search.init();
            order.init();
            amount.init();
            //alpha_pag.init();
            ebook_select.init();
            current_selected.init();

            var isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
            if (isChrome) {
                $('.custom-dropdown').addClass('webkit');
            }

            //is ebook help page, add select class to HELP
            var path = window.location.pathname;
            if (path.toLowerCase().indexOf("ebookhelp") >= 0) {
                $('#menu-about-us-about .menu-item-168').addClass('current-menu-item');
            }

            //if /manuscript-monday
            if (path.toLowerCase().indexOf("manuscript-monday") >= 0) {
                $('#menu-about-us-about .menu-item-166').addClass('current-menu-item');
            }

            //if /anti-piracy-report
            if (path.toLowerCase().indexOf("anti-piracy-report") >= 0) {
                $('#menu-about-us-about .menu-item-165').addClass('current-menu-item');
            }

            setTimeout(function () {
                $('.supapress-sort-by').each(function () {
                    $(this).append('<option value="author-az">Author A - Z</option><option value="author-za">Author Z - A</option>');
                });
            }, 500);

            //remove las comma from results data on search results
            var txt = $('.results-data').text();
            $('.results-data').text(txt.replace(/,\s*$/, ""));

        }//app init
    };


    var current_selected = {
        init: function () {
            var order = $.urlParam('order');
            setTimeout(function () {
                $('option[value="' + order + '"]').prop('selected', true);
            }, 800);
        }
    };

    var toggle_class = {
        init: function () {

            var toggle = $('.toggler');

            toggle.each(function () {
                var t = $(this);

                t.click(function () {
                    var self = $(this),
                        theClass = self.data('class'),
                        target = self.data('target') ? self.data('target') : false;

                    self.toggleClass(theClass);


                    if (target) {
                        $(target).toggleClass(theClass);
                    }
                });

            });
        }
    };

    var order = {
        init: function () {
            $('.authors #order').change(function () {
                window.location = '/authors' + replaceQueryParam('order', $(this).val(), window.location.search);
            });

            $('.events #order').change(function () {
                window.location = '/events' + replaceQueryParam('order', $(this).val(), window.location.search);
            });

            $('.events #order2').change(function () {
                window.location = '/events' + replaceQueryParam('order', $(this).val(), window.location.search);
            });
        }
    };

    var alpha_pag = {
        init: function () {
            $('.alphabetic-pagination a').each(function () {
                $(this).click(function (e) {
                    e.preventDefault();
                    window.location = '/authors' + replaceQueryParam('keyword', $(this).attr('href'), window.location.search);
                });
            });

        }
    };

    var amount = {
        init: function () {
            $('.authors [name="amount"]').each(function () {
                $(this).change(function () {
                    window.location = '/events' + replaceQueryParam('amount', $(this).val(), window.location.search);
                });
            });

            $('.events [name="amount"]').each(function () {
                $(this).change(function () {
                    window.location = '/events' + replaceQueryParam('amount', $(this).val(), window.location.search);
                });
            });
        }
    };

    var ebook_select = {
        init: function () {
            var $dropdownBuy = $(".dropdown-buy span.buy-btn");

            $dropdownBuy.on('click', function (e) {
                $dropdownBuy.parent().toggleClass('open');
            });

        }
    };


    var advanced_search = {
        init: function () {

            $(".dates input").datepicker({ dateFormat: 'mm-dd-yy', altFormat: 'mm-dd-yy' });

            $('.advanced-search .send').on('click', function (e) {
                clear_empty_inputs();
                dates();
            });

            $('#title').on('blur input', function () {
                if ($(this).val()) {
                    $('#restrictSearchByTitle').val('title');
                } else {
                    $('#restrictSearchByTitle').val('');
                }
            });

            $('#contributor').on('blur input', function () {
                if ($(this).val()) {
                    $('#restrictSearchByContributor').val('contributorByLine');
                } else {
                    $('#restrictSearchByContributor').val('');
                }
            });

            $('.dates .fa').on('click', function () {
                $(this).siblings("input").focus();
            });


            function dates() {
                $(".dates input").each(function () {
                    var val = $(this).val();
                    $(".dates input").datepicker({ dateFormat: 'mm-dd-yy', altFormat: 'mm-dd-yy' });
                });
            }

            //disable empty inputs
            function clear_empty_inputs() {
                $('.advanced-search input[type=text], .advanced-search input[type=hidden]').each(function () {
                    var $this = $(this),
                        value = $this.val();

                    if (!value) {
                        $this.prop('disabled', true);
                    }
                    clear_empty_select();
                    //$('.advanced-search form').submit();
                });
            }

            //disable empty inputs
            function clear_empty_select() {
                $('.advanced-search select').each(function () {
                    var $this = $(this),
                        value = $this.val();

                    if (!value) {
                        $this.prop('disabled', true);
                    }
                });
            }

            // function folioAdvanced_goToResults() {
            //     var url = $("#advanced-search").attr('data-url') + "?" + folioAdvanced_getVars();
            //     document.location = url;
            // }

            // function folioAdvanced_getVars() {
            //     var url = "";
            //
            //     $(".folioAdvSearch_filter").each(function() {
            //         var vl = $(this).val();
            //         if( vl !== '' ) {
            //             //AT - if there is an space is probably the full name, so we do keyword search
            //             if( this.id == 'contributor' && vl.match(/\s/) ) {
            //                 url += "&keyword=" + vl + "&search_type=author";
            //             } else if( this.id == 'contributor' && vl.indexOf('-') == -1 ) {
            //                 url += "&keyword=" + vl;
            //             } else if( this.id == 'title' ) {
            //                 url += "&keyword=" + vl;
            //             } else {
            //                 url += "&" + this.id + "=" + vl;
            //
            //                 if( $(this).find(":selected").text() ) {
            //                     url += "&labels[" + this.id + "]=" + encodeURIComponent($(this).find(":selected").text());
            //                 }
            //             }
            //         }
            //
            //     });
            //
            //     url += "&usefilterlabels=1";
            //
            //     return url.replace('&', '');
            //
            // }


            //reable it
            $('.advanced-search input[type=text]').removeAttr('disabled');
            $('.advanced-search select').removeAttr('disabled');

            enable_input_onReset();
            function enable_input_onReset() {
                $('.advanced-search .reset').click(function () {
                    $('.advanced-search input[type=text]').removeAttr('disabled');
                    $('.advanced-search select').removeAttr('disabled');
                });
            }

        }
    };


    app.init();

})(jQuery);